import clsx from '@/lib/clsx';
import WizardCheckbox from './WizardCheckbox';
import WizardCard from './WizardCard';
import WizardDescription from './WizardDescription';
import WizardHeader from './WizardHeader';
import WizardInput from './WizardInput';
import WizardLabel from './WizardLabel';
import WizardLeftPanel from './WizardLeftPanel';
import WizardPanels from './WizardPanels';
import WizardRadio from './WizardRadio';
import WizardRightPanel from './WizardRightPanel';
import WizardSectionHeader from './WizardSectionHeader';
import WizardSectionLabel from './WizardSectionLabel';
import WizardSelect from './WizardSelect';
import WizardSubLabel from './WizardSubLabel';
import WizardTitle from './WizardTitle';
import WizardToggle from './WizardToggle';
import WizardNavigation from './WizardNavigation.jsx';
import WizardYesOrNo from './WizardYesOrNo.jsx';
import WizardQuestionBlock from './WizardQuestionBlock.jsx';
import WizardRadioCards from './WizardRadioCards.jsx';
import WizardInfoBox from './WizardInfoBox';
import WizardFileUpload from './WizardFileUpload';

const Wizard = ({ children, className = '', ...props }) => {
  return (
    <div className={clsx('comp-wizard', className)} {...props}>
      {children}
    </div>
  );
};

const WizardBody = ({ children, className = '', ...props }) => {
  return (
    <div className={clsx('comp-wizard-body', className)} {...props}>
      {children}
    </div>
  );
};

Wizard.Header = WizardHeader;
Wizard.Title = WizardTitle;
Wizard.Panels = WizardPanels;
Wizard.LeftPanel = WizardLeftPanel;
Wizard.RightPanel = WizardRightPanel;
Wizard.Label = WizardLabel;
Wizard.SubLabel = WizardSubLabel;
Wizard.SectionLabel = WizardSectionLabel;
Wizard.SectionHeader = WizardSectionHeader;
Wizard.Description = WizardDescription;
Wizard.Card = WizardCard;
Wizard.Input = WizardInput;
Wizard.Select = WizardSelect;
Wizard.Checkbox = WizardCheckbox;
Wizard.Radio = WizardRadio;
Wizard.Body = WizardBody;
Wizard.Toggle = WizardToggle;
Wizard.Navigation = WizardNavigation;
Wizard.YesOrNo = WizardYesOrNo;
Wizard.QuestionBlock = WizardQuestionBlock;
Wizard.RadioCards = WizardRadioCards;
Wizard.InfoBox = WizardInfoBox;
Wizard.FileUpload = WizardFileUpload;

export default Wizard;
